export const equipment = [
  {
    key: "geofono-hl7000",
    name: "Geofono HL7000",
    model: "sebaKMT HL7000",
    image: "/images/optimized/gallery-5-600.webp",
    desc_it: "Geofono elettroacustico di ultima generazione sebaKMT (Megger) HL7000 per l'ascolto delle perdite in pressione. Funziona su pavimenti, muri, asfalto e tratti interrati.",
    desc_en: "Latest-generation sebaKMT (Megger) HL7000 electroacoustic geophone for pressurized leak listening. Floors, walls, asphalt and buried lines.",
    use_it: "Perdite occulte in tubazioni in pressione, individuazione precisa del punto da aprire \u2014 il nostro strumento principale.",
    use_en: "Hidden pressurized pipe leaks, centimeter-level localization \u2014 our main tool.",
  },
  {
    key: "sebakmt-hydrolux",
    name: "sebaKMT HYDROLUX",
    model: "HYDROLUX HL",
    image: "/images/optimized/intervento-1-600.webp",
    desc_it: "Sistema di pre-localizzazione acustica HYDROLUX: misura il rumore della perdita in dB con grafico in tempo reale e GPS.",
    desc_en: "HYDROLUX acoustic pre-localization system: measures leak noise in dB with real-time graph and GPS.",
    use_it: "Pre-localizzazione su pozzetti, idranti, contatori \u2014 restringe la zona prima del geofono.",
    use_en: "Pre-localization on manholes, hydrants, meters \u2014 narrows the zone before the geophone.",
  },
  {
    key: "sonda-ld6000",
    name: "Sonda acustica LD6000",
    model: "LD6000",
    image: "/images/optimized/intervento-2-600.webp",
    desc_it: "Sonda acustica di precisione per amplificare il rumore delle micro-perdite anche in ambienti rumorosi (bagni, cucine, locali tecnici).",
    desc_en: "Precision acoustic probe to amplify micro-leak noises even in noisy environments (bathrooms, kitchens, plant rooms).",
    use_it: "Conferma rapida del punto perdita su sanitari e tubazioni a vista.",
    use_en: "Fast confirmation of leak point on fixtures and visible pipes.",
  },
  {
    key: "cercaservizi",
    name: "Cercaservizi e Sonde trancianti",
    model: "GPR + Cutting probes",
    image: "/images/optimized/cercaservizi.webp",
    desc_it: "Sistema di mappatura dei sottoservizi (tubi acqua, gas, elettrici) e sonde trancianti per diagnostica scarichi: vediamo prima di scavare.",
    desc_en: "Underground utility mapping (water, gas, electric pipes) and cutting probes for drain diagnostics: we see before we dig.",
    use_it: "Localizzazione tubi sepolti e individuazione percorsi prima di interventi.",
    use_en: "Locating buried pipes and routes before any intervention.",
  },
  {
    key: "termocamere",
    name: "Termocamere",
    model: "FLIR / Trotec",
    image: "https://images.unsplash.com/photo-1698395950317-4590f514be78?auto=format&fit=crop&w=900&q=70",
    desc_it: "Termocamere ad alta risoluzione per individuare differenze termiche dovute all'acqua. Ottime per acqua calda e infiltrazioni recenti.",
    desc_en: "High-resolution thermal cameras for water-related temperature differences. Great for hot water and recent infiltrations.",
    use_it: "Mappatura termica di muri, soffitti, pavimenti, tetti.",
    use_en: "Thermal mapping of walls, ceilings, floors, roofs.",
  },
  {
    key: "gas-tracciante",
    name: "Gas tracciante non tossico",
    model: "N2/H2 95/5",
    image: "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?auto=format&fit=crop&w=900&q=70",
    desc_it: "Miscela azoto-idrogeno 95/5 sicura, non tossica, che non altera il valore organolettico dell'acqua. Si immette nel tratto sospetto e il sensore di superficie individua il punto preciso.",
    desc_en: "95/5 nitrogen-hydrogen mix, safe, non-toxic, doesn't alter water taste. Injected into the suspect pipe, our surface sensor pinpoints the exact spot.",
    use_it: "Localizzazione di perdite dove geofono e termocamera non arrivano.",
    use_en: "Locating leaks where geophone and thermal can't reach.",
  },
  {
    key: "trotec-pd200",
    name: "Trotec PD200",
    model: "PD200",
    image: "https://images.unsplash.com/photo-1572120360610-d971b9b78825?auto=format&fit=crop&w=900&q=70",
    desc_it: "Misuratore di umidit\u00e0 ad alta precisione per murature, tetti, terrazzi e solai. Mappa la propagazione dell'acqua nei materiali.",
    desc_en: "High-precision moisture meter for masonry, roofs, terraces and slabs. Maps water diffusion in materials.",
    use_it: "Diagnosi infiltrazioni tetti, terrazzi, pareti perimetrali.",
    use_en: "Diagnosing roof, terrace and perimeter wall infiltrations.",
  },
  {
    key: "video-ispezione",
    name: "Video ispezione HD",
    model: "HD camera",
    image: "https://images.unsplash.com/photo-1611843467160-25afb8df1074?auto=format&fit=crop&w=900&q=70",
    desc_it: "Telecamera ad alta definizione per ispezione scarichi e collettori, con registrazione e metratura del punto.",
    desc_en: "HD camera for drain and manifold inspection, with recording and point measurement.",
    use_it: "Otturazioni, rotture, schiacciamenti, infiltrazioni di radici.",
    use_en: "Clogs, breaks, crushes, root intrusions.",
  },
];
